import { Api } from "../../core/services/api.services";
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain";
import { BCFormList } from "../../shared/styled/global.styled";
import { useService } from "../../hook/useServices";
import { UserCognito, User } from "../../shared/interface/users";
import { Role } from "../../constants/roles";

const getUsers = async () => {
  const { data } = await Api.getUsers('10');
  return data;
};

const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    hour12: "false",
    minute: "numeric",
  };

const UsersPage = () => {

  const serviceQuery = useService('userCognito', getUsers);
  const users = serviceQuery.data as UserCognito;
  
  return (
    <LayoutMain idPage="Usuarios" titlePage={true} requiredRoles={[Role.COGNITO]}>
      {serviceQuery.isLoading && <div className="bc-preloader bc-preloader-line"></div> }
      {users?.Users && users.Users.map((user: User) => (
          <BCFormList className="bc-card" key={user.Username}>
            <h6>Username: </h6>
            <p>{user.Username}</p>
            <h6>Fecha de creación: </h6>
            <p>{`${new Date(user.UserCreateDate).toLocaleString("es-ES", options as any)}`}</p>
            <h6>Ultima modificacion: </h6>
            <p>{`${new Date(user.UserLastModifiedDate).toLocaleString("es-ES", options as any)}`}</p>
          </BCFormList>
        ))}
    </LayoutMain>
  );
};

export default UsersPage;
